// (tag: String, attrs: Object|Null) => HTMLElement
export default (tag, attrs = {}) => {
  const element = document.createElement(tag);
  Object.keys(attrs).forEach(key => element.setAttribute(key, attrs[key]));

  return element;
};
